import React, { Component } from 'react';
import { branch } from 'baobab-react/higher-order';
import Helmet from 'react-helmet';
import Sticky from 'react-sticky-el';
import { Link as ScrollLink } from 'react-scroll';
import Overview from './Overview';
import Breadcrumb from '../common/Breadcrumb';
import BreadcrumbItem from '../common/BreadcrumbItem';
import Cookies from 'js-cookie';
// import OptInPopup from "../components/OptInPopup";
//import Modal from "react-modal";
import NotFound from "../notFound/NotFound";
import { buildPdpProductArrayForPush, pushNewEcommerceEvent } from "../../utils/datalayer";

class ProductDetail extends Component {

	constructor(props) {
		super(props);
		this.scrollToTop = this.scrollToTop.bind(this);
		this.state = {
			optInModalOpen: true,
			standard: true,
			optInCookieValue: Cookies.get('OPTIN')
		}
	}

	componentDidMount() {
		let optInCookieValue = this.state.cookieValue;

		if (optInCookieValue === undefined) {
			this.optInModalOpen = true;
		} else {
			this.optInModalOpen = false;
		}
		//console.log('overview', this.props.product);
		const items = buildPdpProductArrayForPush(this.props.product);
		//console.log(items)
		const { ecommerceSalesPrice, ecommerceRegularPrice } = this.props.product;
		const price = ecommerceSalesPrice || ecommerceRegularPrice || undefined;
		pushNewEcommerceEvent('view_item', items, null, 'USD', price.toString());
	}

	selectStandard(flag) {
		this.setState({ standard: flag });
		let eventLabel;
		if (flag) {
			eventLabel = 'Standard';
		} else {
			eventLabel = 'Metric';
		}
		global.dataLayer.push({
			event: 'Utility Navigation',
			eventCategory: 'Utility Nav',
			eventAction: 'Standard / Metric',
			eventLabel
		});
	}

	toggleSwitch() {
		let eventLabel;
		if (this.state.standard === false) {
			this.setState({ standard: true });
			eventLabel = 'Standard';
		} else {
			this.setState({ standard: false });
			eventLabel = 'Metric';
		}
		global.dataLayer.push({
			event: 'Utility Navigation',
			eventCategory: 'Utility Nav',
			eventAction: 'Standard / Metric',
			eventLabel
		});
	}

	scrollToTop() {
		scroll.scrollToTop();
	}

	handleNavClick(e) {
		global.dataLayer.push({
			event: 'Sub Nav',
			eventCategory: 'Sub Navigation',
			eventAction: global.location.pathname,
			eventLabel: e.currentTarget.textContent
		});
	}

	render() {
		if (this.props.product == null) {
			return <NotFound />
		}
		const productOverview = this.props.product.overView;
		let metaDescription;

		if (this.props.product.metaDescription) {
			metaDescription = (
				<meta name="description" content={this.props.product.metaDescription} />
			);
		}

		let canonical = "https://www.sentrysafe.com/product/" + productOverview.modelNumber;

		// Meta title for product QAP2BEL is too long for SEO purposes
		var modelNumber = productOverview.modelNumber === "QAP2BEL" ? "" : `${productOverview.modelNumber} | `;

		var accessoriesLength = this.props.product.productAccessories.length;
		var accessoriesLink = "";
		if (accessoriesLength > 0) {
			accessoriesLink =
				<li>
					<ScrollLink
						activeClass="active"
						to="product-accessories"
						spy={true}
						smooth={true}
						offset={-46}
						duration={500}
						onSetActive={this.handleSetActive}
						onClick={e => this.handleNavClick(e)}
					>
						Accessories
					</ScrollLink>
				</li>
		}

		// let optInModal = "";
		// if(this.optInModalOpen) {
		// 	optInModal= <OptInPopup />
		// }


		return (
			<div className="product-details">
				<Helmet>
					<title>
						{productOverview.pageTitleDescription ? `${productOverview.pageTitleDescription}` : `${productOverview.description}`} | {modelNumber}SentrySafe
					</title>
					{metaDescription}
					<link rel="canonical" href={canonical} />

					<meta id="ps-key" name="ps-key" content="5865-63407f5c32074b0023f97328"></meta>
					<meta name="ps-country" content="US" />
					<meta name="ps-language" content="en" />

					<script id='pdp-index-helmet_ps-widget' type="text/javascript" src="https://cdn.pricespider.com/1/lib/ps-widget.js" async></script>
					<script id='pdp-index-helmet_ps-utid' type="text/javascript" src="https://cdn.pricespider.com/1/5865/ps-utid.js" async></script>
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem path="/products" label="Products" />
					<BreadcrumbItem label={`${productOverview.description} ${productOverview.modelNumber}`} />
				</Breadcrumb>

				<Sticky className="page-nav">
					<div className="row">
						<div className="col">
							<ul>
								<li>
									<ScrollLink
										activeClass="active"
										to="features"
										spy={true}
										smooth={true}
										offset={-46}
										duration={500}
										onSetActive={this.handleSetActive}
										onClick={e => this.handleNavClick(e)}
									>
										Features
									</ScrollLink>
								</li>
								<li>
									<ScrollLink
										activeClass="active"
										to="specifications"
										spy={true}
										smooth={true}
										offset={-46}
										duration={500}
										onSetActive={this.handleSetActive}
										onClick={e => this.handleNavClick(e)}
									>
										Specifications
									</ScrollLink>
								</li>
								{accessoriesLink}
								<li>
									<ScrollLink
										activeClass="active"
										to="support"
										spy={true}
										smooth={true}
										offset={-46}
										duration={500}
										onSetActive={this.handleSetActive}
										onClick={e => this.handleNavClick(e)}
									>
										Support
									</ScrollLink>
								</li>
								<li>
									<ScrollLink
										activeClass="active"
										to="BVRRContainer"
										spy={true}
										smooth={true}
										offset={-46}
										duration={500}
										onSetActive={this.handleSetActive}
										onClick={e => this.handleNavClick(e)}
									>
										Reviews
									</ScrollLink>
								</li>
							</ul>
							<ul className="unit-select">
								<li>
									<a
										className={this.state.standard ? 'active' : ''}
										onClick={() => this.selectStandard(true)}
									>
										Standard
									</a>
								</li>
								<li>
									<label htmlFor="unitSwitch" className="switch">
										<input
											type="checkbox"
											id="unitSwitch"
											className={this.state.standard ? '' : 'active'}
											onClick={() => this.toggleSwitch(false)}
										/>
										<span className="slider">Standard / Metric</span>
									</label>
								</li>
								<li>
									<a
										className={this.state.standard ? '' : 'active'}
										onClick={() => this.selectStandard(false)}
									>
										Metric
									</a>
								</li>
							</ul>
						</div>
					</div>
				</Sticky>

				<ul className="unit-select sm-show">
					<li>
						<a
							className={this.state.standard ? 'active' : ''}
							onClick={() => this.selectStandard(true)}
						>
							Standard
						</a>
					</li>
					<li>
						<label htmlFor="unitSwitchMobile" className="switch">
							<input
								type="checkbox"
								id="unitSwitchMobile"
								className={this.state.standard ? '' : 'active'}
								onClick={() => this.toggleSwitch(false)}
							/>
							<span className="slider">Standard / Metric</span>
						</label>
					</li>
					<li>
						<a
							className={this.state.standard ? '' : 'active'}
							onClick={() => this.selectStandard(false)}
						>
							Metric
						</a>
					</li>
				</ul>

				<Overview standard={this.state.standard} />
				{/*<OptInPopup />*/}
			</div>
		);
	}
};

export default branch({
	product: ['product']
}, ProductDetail);



// WEBPACK FOOTER //
// ./src/pages/product/ProductDetail.js